import { createApp } from 'vue'
import { createHead } from '@vueuse/head'
import App from './App.vue'
import router from './router'
// import i18n from './i18n' // Nonaktifkan i18n sementara
import Particles from "particles.vue3"
import revealDirective from './directives/v-reveal'
import './composables/useDarkMode' // Initialize dark mode
import './assets/dark-mode.css' // Dark mode styles
import './styles/index.css' // Global design tokens and shared styles


const app = createApp(App)
const head = createHead()

app.use(head)
app.use(router)
  // .use(i18n) // Nonaktifkan i18n sementara
  .use(Particles)
  .directive('reveal', revealDirective)

  .mount('#app')
